import { DebugKv, DebugSection } from '../DebugSection';

export interface FeatureFlagsSectionProps { searchTerm?: string }

export function FeatureFlagsSection({ searchTerm }: FeatureFlagsSectionProps): JSX.Element {
  const env = import.meta.env as unknown as Record<string, unknown>;
  const rows: Array<{ k: string; v: unknown }> = [];
  for (const key of Object.keys(env)) {
    if (key.startsWith('VITE_FEATURE_')) {
      rows.push({ k: key, v: env[key] });
    }
  }
  if (typeof window !== 'undefined') {
    try {
      for (let i = 0; i < window.localStorage.length; i++) {
        const k = window.localStorage.key(i);
        if (k && k.startsWith('pcb.flag.')) {
          rows.push({ k, v: window.localStorage.getItem(k) });
        }
      }
    } catch { /* ignore */ }
  }

  return (
    <DebugSection id="flags" title="12. Feature flags" count={rows.length} searchTerm={searchTerm}>
      {rows.length === 0 ? (
        <div className="pcb-debug-empty">No VITE_FEATURE_* env vars or pcb.flag.* localStorage keys.</div>
      ) : (
        <DebugKv rows={rows} searchTerm={searchTerm} />
      )}
    </DebugSection>
  );
}
